const DocMenuConfig = [
  {
    pages: [
      {
        heading: "menu.dashboard",
        route: "/dashboard",
        svgIcon: "media/icons/duotune/art/art002.svg",
        fontIcon: "bi-house",
      },
    ],
  },
  {
    heading: "menu.cursos",
    pages: [
      {
        heading: "menu.cursos",
        route: "/listados/cursos",
        fontIcon: "bi bi-backpack",
      },
    ],
  },
  {
    heading: "menu.designContenido",
    pages: [
      {
        heading: "menu.home",
        route: "/website/inicio",
        fontIcon: "bi bi-window",
      },
      {
        heading: "menu.plantillasEmail",
        route: "/website/plantillas-email",
        fontIcon: "bi bi-envelope",
      },
    ],
  },
  {
    heading: "menu.usuarios",
    pages: [
      {
        heading: "menu.usuariosListado",
        route: "/listados/personal",
        fontIcon: "bi bi-people",
      },
    ],
  },
  /*  {
    heading: "menu.documentacion",
    pages: [
      {
        heading: "menu.manual",
        link: "https://google.es",
        fontIcon: "bi bi-life-preserver",
      },
    ],
  },
  */
];

export default DocMenuConfig;
